<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import {
  SCHEDULED_VISITS_ORDER_BY_QUERY,
  SCHEDULED_VISITS_TEXT,
} from '../utils/visitScheduledPresenter';

defineProps({
  modelValue: {
    type: String,
    default: SCHEDULED_VISITS_ORDER_BY_QUERY.CLOSER_VISITS,
  },
});

const emit = defineEmits(['update:modelValue']);

const OPTIONS = Object.freeze([
  {
    value: SCHEDULED_VISITS_ORDER_BY_QUERY.CLOSER_VISITS,
    label: SCHEDULED_VISITS_TEXT.ORDER_BY_CLOSEST_VISITS,
  },
  {
    value: SCHEDULED_VISITS_ORDER_BY_QUERY.NEW_CLIENTS,
    label: SCHEDULED_VISITS_TEXT.ORDER_BY_NEW_CLIENTS,
  },
  {
    value: SCHEDULED_VISITS_ORDER_BY_QUERY.NAME,
    label: SCHEDULED_VISITS_TEXT.ORDER_BY_ALPHABETICAL,
  },
]);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <label class="inline-flex items-center gap-2 text-[13px] text-lais-text-body">
    <span class="font-semibold">{{
      SCHEDULED_VISITS_TEXT.ORDER_BY_LABEL
    }}</span>
    <select
      :value="modelValue"
      class="rounded-full border border-lais-border bg-white px-3 py-1 text-[12px] font-semibold"
      @change="emit('update:modelValue', $event.target.value)"
    >
      <option
        v-for="option in OPTIONS"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </label>
</template>
